(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';
  
  class CategorySlider {
    constructor() {
      this.slider = null;
      this.prevButton = null;
      this.nextButton = null;
      this.scrollAmount = 220;
      this.init();
    }
    
    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupSlider());
      } else {
        this.setupSlider();
      }
    }
    
    setupSlider() {
      this.slider = document.querySelector('.shop-by-category__slider');
      this.prevButton = document.querySelector('.shop-by-category__prev');
      this.nextButton = document.querySelector('.shop-by-category__next');
      
      if (!this.slider || !this.prevButton || !this.nextButton) {
        console.error('Slider elements not found');
        return;
      }
      
      console.log('Slider properties:', {
        scrollWidth: this.slider.scrollWidth,
        clientWidth: this.slider.clientWidth,
        scrollLeft: this.slider.scrollLeft,
        canScroll: this.slider.scrollWidth > this.slider.clientWidth
      });
      
      // Add event listeners
      this.prevButton.addEventListener('click', (e) => this.handlePrevClick(e));
      this.nextButton.addEventListener('click', (e) => this.handleNextClick(e));
      
      console.log('Slider initialized successfully');
    }
    
    handlePrevClick(e) {
      e.preventDefault();
      console.log('Prev clicked, current scrollLeft:', this.slider.scrollLeft);
      this.slider.scrollBy({
        left: -this.scrollAmount,
        behavior: 'smooth'
      });
      setTimeout(() => {
        console.log('After scroll, scrollLeft:', this.slider.scrollLeft);
      }, 500);
    }
    
    handleNextClick(e) {
      e.preventDefault();
      console.log('Next clicked, current scrollLeft:', this.slider.scrollLeft);
      this.slider.scrollBy({
        left: this.scrollAmount,
        behavior: 'smooth'
      });
      setTimeout(() => {
        console.log('After scroll, scrollLeft:', this.slider.scrollLeft);
      }, 500);
    }
  }
  
  // Initialize the slider
  new CategorySlider();
})();

  } catch(e) { console.error(e); }
})();
})();
